module.exports = __webpack_public_path__ + "static/media/EduShare_Logo_Homepage_Big.b36ff783.png";